import React, { useEffect, useState } from "react";
import AuthService from "../../Components/auth/AuthService";
import ActionButtons from "../../Components/common/ActionButtons";
import { Button as AntButton, Input, Divider, Typography, Col, Row, Select, Tag, Modal, Card, Form, notification } from "antd";
import { ArrowLeftOutlined, BarcodeOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/system";
import { useSelector } from "react-redux";
import { hideLoading, showLoading, useLoadingDispatch } from "../../context/loadingContext";
import './dashboard.css'
import ScanSelect from "../Scan/ScanSelect";
import { showMessage } from "../../Components/Utils/message";
import dayjs from "dayjs";
import ProductScanSelect from "../Scan/ProductScanSelect";

const DataSheet = styled('div')`
   .ant-input[disabled] {
      background: rgb(240, 240, 240);
      color: black;
    }
`;

const TransferStock = () => {
  const Auth = new AuthService();
  const layoutDispatch = useLoadingDispatch();
  const navigate = useNavigate()
  const { Title, Text } = Typography;
  const { locations, products } = useSelector((state) => state?.AppState?.userCreds);
  const { Option } = Select;
  const [transferStock, setTranferStock] = useState({
    product: "",
    product_code: '',
    location: "",
    quantity: "",
    dispatchLocation: "",
    product_id: '',
    location_id: null,
    dispatch_location_id: null,
    productText: '',
    locationText: '',
    dispatchLocationText: '',
    productStatus: null,
    locationStatus: null,
    dispatchLocationStatus: null,
    batch_id: null,
    batch_expiry: null,
    batch_quantity: '',
    batch_code: '',
    supplier_batch_code: '',

  });
  const [selectedLocationsBatches, setSelectedLocationBatches] = useState([])
  const [selectedProductLocations, setSelectedProductLocations] = useState([])
  const [dispatchLocations, setDispatchLocations] = useState([])

  const getLocations = async () => {
    showLoading(layoutDispatch)

    try {
      const res = await Auth.fetch(`/location/locations`);
      if (res?.ack) {
        console.log(res?.locations, 'locations');
        setDispatchLocations(res?.locations)
      } else {
        showMessage('err', res?.message)
        setDispatchLocations([])
      }
    } catch (err) {
      console.log(err);
      showMessage('error', 'something went wrong')
    } finally {
      hideLoading(layoutDispatch)
    }
  };

  useEffect(() => {
    getLocations();
  }, []);

  const locationSelectValueChange = (val, isScanned) => {
    console.log('locationSelectValueChange', val, isScanned);
    if (!transferStock?.product_id) {
      showMessage('error', 'Please select a product first')
      setTranferStock({ ...transferStock, location_id: null })
      return;
    }
    if (isScanned) {
      const matched = selectedProductLocations?.find(item => item.code == val);
      console.log(matched, 'matched');

      if (matched) {
        setTranferStock({ ...transferStock, location_id: matched.id, batch_code: null, supplier_batch_code: null, batch_expiry: null, batch_id: null, batch_quantity: "", quantity: '' , dispatch_location_id: null});
        getLocationBatches(matched?.id, transferStock?.product_id)

      } else {
        showMessage('error', "No matching location");
      }
    } else {
      setTranferStock({ ...transferStock, location_id: val, batch_code: null, supplier_batch_code: null, batch_expiry: null, batch_id: null, batch_quantity: "", quantity: '', dispatch_location_id: null });
      getLocationBatches(val, transferStock?.product_id)
    }
  };

  const dispatchLocationSelectValueChange = (val, isScanned) => {
    if (!transferStock?.product_id) {
      showMessage('error', 'Please select a product first')
      setTranferStock({ ...transferStock, dispatch_location_id: null })
      return;
    }
    if (isScanned) {
      const matched = locations?.find(item => item.code === val);
      if (matched) {
        setTranferStock({ ...transferStock, dispatch_location_id: matched.id });
      } else {
        showMessage('error', "No matching location");
      }
    } else {
      setTranferStock({ ...transferStock, dispatch_location_id: val });
    }
  };

  const getProductLocations = async (product_id) => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/product-location/location-stock-by-product-batches?id=${product_id}`)
      if (res?.ack) {
        const resLocations = res?.product_location || [];

        const matchedLocations = locations
          ?.map(loc => {
            const matchedRes = resLocations.find(r => r.location_id === loc.id);
            if (matchedRes) {
              return {
                ...loc,
                quantity: matchedRes.quantity || 0, // push quantity from response
              };
            }
            return null;
          })
          .filter(Boolean) // remove unmatched
          .sort((a, b) => (b.is_picking || 0) - (a.is_picking || 0)); // sort by is_picking


        setSelectedProductLocations(matchedLocations || []);
      } else {
        showMessage('error', res?.message);
      }
    } catch (err) {
      showMessage('error', 'Something went wrong');
    } finally {
      hideLoading(layoutDispatch);
    }
  }

  const productSelectValueChange = (val, isScanned) => {
    if (isScanned) {
      const selectedProduct = products?.find((pro) => pro?.code == val || pro?.barcode == val);
      if (selectedProduct) {
        setTranferStock({ ...transferStock, product_id: selectedProduct?.netsuite_id, product: selectedProduct?.name, product_code: selectedProduct?.code, location_id: null, quantity: '', });
        getProductLocations(selectedProduct?.netsuite_id);
      } else {
        setTranferStock({ ...transferStock, product_id: null, location_id: null, quantity: '', product: '', product_code: '' });
        setSelectedProductLocations([]);
        showMessage('error', 'Invalid product selected')
      }

    } else {
      const selectedProduct = products?.find((pro) => pro?.netsuite_id == val);
      if (selectedProduct) {
        setTranferStock({ ...transferStock, product_id: val, product: selectedProduct?.name, product_code: selectedProduct?.code, location_id: null, quantity: '' });
        getProductLocations(val);

      } else {
        setTranferStock({ ...transferStock, product_id: null, location_id: null, quantity: '', product: '', product_code: '' });
        setSelectedProductLocations([]);
        showMessage('error', 'Invalid product selected')
      }
    }
  };

  const handleTransferStock = async () => {
    if (!transferStock?.product || !transferStock?.location_id || !transferStock?.quantity || !transferStock?.dispatch_location_id) {
      showMessage('error', 'Fill all required fields')
      return;
    };

    if (transferStock?.location_id == transferStock?.dispatch_location_id) {
      showMessage('error', 'Source and Destination location cannot be same')
      return;
    };

    const dataToSend = {
      product_netsuite_id: transferStock?.product_id,
      source_location_id: transferStock?.location_id,
      dest_location_id: transferStock?.dispatch_location_id,
      quantity: transferStock?.quantity,
      batch_id: transferStock?.batch_id,
      supplier_batch_code: transferStock?.supplier_batch_code,
      batch_code: transferStock?.batch_code,
      expiry_date: transferStock?.batch_expiry ? dayjs(transferStock?.batch_expiry).format('YYYY-MM-DD') : null,
    };

    const submitStock = async (payload) => {
      showLoading(layoutDispatch);
      try {
        const res = await Auth.fetch('/stock/transfer-stock', {
          method: 'POST',
          body: JSON.stringify(payload),
        });

        if (res?.ack) {
          showMessage('success', res?.message)
          setTranferStock({ product: "", product_id: '', product_code: '', location: "", location_id: '', dispatchLocation: '', dispatch_location_id: '', quantity: "", productText: '', locationText: '', dispatchLocationText: '', dispatchLocationStatus: null, productStatus: null, locationStatus: null })
          setSelectedProductLocations([])
          getLocations()

        } else {
          showMessage('error', res?.message);

          if (res?.capacity_increased_by) {
            const cases_in_pallets = products?.find(pro => pro?.netsuite_id == transferStock?.product_id)?.cases_in_pallets || 0;
            const capcityCal = res?.capacity_increased_by * cases_in_pallets;
            const plusSignWithCapcity = capcityCal < 0 ? `${Math.abs(capcityCal)}` : capcityCal;
            if (plusSignWithCapcity >= cases_in_pallets) return showMessage('error', 'Please select another location, this location capacity is full');
            Modal.confirm({
              title: "Capacity Exceeded",
              content: (
                <div style={{ fontSize: 16 }}>
                  Location capacity exceeded by{" "}
                  <span style={{ color: "green", fontWeight: "bold", fontSize: 18 }}>
                    {Number(plusSignWithCapcity)?.toFixed(2)}
                  </span>{" "}
                  cases. Do you want to receive the stock anyway?
                </div>
              ),
              okText: "Yes",
              cancelText: 'Cancel',
              width: 600,
              okButtonProps: { size: "large" },
              cancelButtonProps: { size: "large" },
              onOk: () => submitStock({ ...payload, bypass_capacity_check: true })
            });
          }
        }
      } catch (err) {
        console.log(err);
        showMessage('error', 'Something went wrong');
      } finally {
        hideLoading(layoutDispatch)
      }
    };
    submitStock(dataToSend);


  };

  const getLocationBatches = async (location_id, product_id) => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/stock/location-batches?location_id=${location_id}&product_netsuite_id=${product_id}`);
      if (res?.ack) {
        setSelectedLocationBatches(res?.location_batches)
        showMessage('success', res?.message);

      } else {
        showMessage('error', res?.message);
        hideLoading(layoutDispatch);
      }
    } catch (err) {
      console.log(err);
      showMessage('error', err?.message);
      hideLoading(layoutDispatch);
    } finally {
      hideLoading(layoutDispatch)
    }
  }

  return (
    <DataSheet>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: 'center', marginBottom: '10px' }}>
        <h3 style={{ margin: 0 }}>Transfer Stock</h3>
        <AntButton icon={<ArrowLeftOutlined />} onClick={() => navigate("/stocks")}>Back</AntButton>            
      </div>
      
      <Row gutter={[16, 16]}>
        <Col xs={24} lg={12}>
          <Card title="Source"  style={{ boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
            <Form name="source" layout="vertical" size="large">
              <Form.Item label="Product">
                <ProductScanSelect
                  onValueChange={productSelectValueChange}
                  value={transferStock?.product_id}
                  options={products}
                  placeholder="Product"
                  length={'100%'}
                />
              </Form.Item>

              <Form.Item label="Location">
                <ScanSelect
                  onValueChange={locationSelectValueChange}
                  value={transferStock?.location_id}
                  options={selectedProductLocations}
                  placeholder="Location"
                  length={'100%'}
                />
              </Form.Item>

              {transferStock?.location_id > 0 && <Form.Item label="Location Batches">
                <Select
                  placeholder="Location Batches"
                  size="large"
                  showSearch
                  style={{ width: '100%' }}
                  filterOption={(input, option) =>
                    option?.label?.props?.children
                      ?.map?.(el => typeof el === 'string' ? el : '')
                      .join(' ')
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  value={transferStock?.batch_id}
                  onChange={(value) => {
                    const selectedBatch = selectedLocationsBatches?.find((item) => item.batch_id === value);
                    const expiryDate = selectedBatch?.expiry_date ? dayjs(selectedBatch.expiry_date) : null;
                    const daysToExpire = expiryDate ? expiryDate.diff(dayjs(), 'day') : null;
                   if (daysToExpire < 0) {
                    Modal.confirm({
                      title: "Expired Batch Selected",
                      content: `The batch you selected expired on ${expiryDate.format(
                        "DD-MM-YYYY"
                      )}. Do you still want to use it?`,
                      okText: "Yes, Continue",
                      cancelText: "No",
                      onOk: () => {
                        setTranferStock({
                          ...transferStock,
                          batch_id: value,
                          quantity: "",
                          batch_expiry: selectedBatch?.expiry_date,
                          batch_quantity: selectedBatch?.stock_level,
                          batch_code: selectedBatch?.batch_code,
                          supplier_batch_code: selectedBatch?.supplier_batch_code,
                        });
                      },
                    });
                    return;
                  }
                    setTranferStock({
                      ...transferStock,
                      batch_id: value,
                      quantity: '',
                      batch_expiry: selectedBatch?.expiry_date,
                      batch_quantity: selectedBatch?.stock_level,
                      batch_code: selectedBatch?.batch_code,
                      supplier_batch_code: selectedBatch?.supplier_batch_code
                    });
                  }}
                  optionLabelProp="label"
                >
                  {selectedLocationsBatches.map((item) => {
                    const expiryDate = item?.expiry_date ? dayjs(item.expiry_date) : null;
                    const daysToExpire = expiryDate ? expiryDate.diff(dayjs(), 'day') : null;
                    const expiryColor = !expiryDate ? 'default' : daysToExpire < 0 ? 'red' : daysToExpire <= 30 ? 'orange' : 'green';
                    const label = (
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <Tag color="blue" style={{ margin: 0 }}>Qty: {item?.stock_level}</Tag>
                        <Tag color={expiryColor} style={{ margin: 0 }}>
                          Exp: {expiryDate ? expiryDate.format('DD-MM-YYYY') : 'N/A'}
                        </Tag>
                      </div>
                    );
                    return (
                      <Option key={item.batch_id} value={item.batch_id} label={label}>
                        <div style={{
                          padding: '8px 12px',
                          margin: '4px 0',
                          border: '1px solid #f0f0f0',
                          borderRadius: '8px',
                          backgroundColor: '#fafafa',
                        }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                            <Tag color="blue" style={{ fontWeight: 'bold', marginRight: 4 }}>
                              Qty: {item?.stock_level}
                            </Tag>
                            <Tag color={expiryColor} style={{ fontSize: '13px', fontWeight: 500 }}>
                              Exp: {expiryDate ? expiryDate.format('DD-MM-YYYY') : 'N/A'}
                            </Tag>
                          </div>
                          {item?.supplier_batch_code && (
                            <div style={{ fontSize: '12px', color: '#666' }}>
                              Batch Code: <span style={{ fontWeight: 500 }}>{item?.supplier_batch_code}</span>
                            </div>
                          )}
                        </div>
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>}
              
              <Form.Item label="Quantity">
                <Input
                  type="number"
                  value={transferStock?.quantity}
                  onChange={(e) => {
                    if (!transferStock?.product_id) return showMessage('error', 'select a product first');
                    if (!transferStock?.location_id) return showMessage('error', 'select a location first');
                    if (!transferStock?.batch_id) return showMessage('error', 'select a location batch first');
                    if (e.target.value.includes('.')) return
                    if (e.target.value < 0) return showMessage('error', 'Quantity must be at least 1');
                    if (Number(e.target.value) > transferStock?.batch_quantity) return showMessage('error', 'Quantity cannot be greater than batch quantity');
                    setTranferStock({ ...transferStock, quantity: e.target.value });
                  }}
                  placeholder="Quantity"
                />
              </Form.Item>
            </Form>
          </Card>
        </Col>
        <Col xs={24} lg={12}>
          <Card title="Destination" style={{ boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
            <Form name="destination" layout="vertical" size="large">
              <Form.Item label="Product">
                <Input
                  size="large"
                  value={transferStock.product_code ? `${transferStock.product_code} - ${transferStock.product}` : null}
                  placeholder="Dispatch Product"
                  prefix={<BarcodeOutlined style={{ fontSize: 23 }} />}
                  readOnly
                />
              </Form.Item>

              <Form.Item label="Dispatch Location">
                <ScanSelect
                  onValueChange={dispatchLocationSelectValueChange}
                  value={transferStock?.dispatch_location_id}
                  options={transferStock?.location_id ? dispatchLocations?.filter(item => item?.id != transferStock?.location_id) : []}
                  placeholder="Dispatch Location"
                  length={'100%'}
                  capacityCheck={true}
                />
              </Form.Item>

             {transferStock?.location_id > 0 && <Form.Item label="Location Batch">
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    padding: '8px 12px',
                    border: '1px solid #d9d9d9',
                    borderRadius: 6,
                    background: '#fafafa',
                  }}
                >
                  <Tag color="blue" style={{ fontWeight: 'bold', margin: 0 }}>
                    Qty: {transferStock?.batch_quantity || 'N/A'}
                  </Tag>
                  <Tag color="red" style={{ fontSize: '13px', fontWeight: 500, margin: 0 }}>
                    Exp: {transferStock?.batch_expiry ? dayjs(transferStock?.batch_expiry).format('DD-MM-YYYY') : 'N/A'}
                  </Tag>
                </div>
              </Form.Item>}

              <Form.Item label="Quantity">
                <Input type="number" readOnly value={transferStock?.quantity} placeholder="Quantity" />
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
      
      <Divider />
      <ActionButtons
        handleSave={handleTransferStock}
        title={"Transfer Stock"}
        content={'Are you sure to transfer this stock'}
      />
    </DataSheet>

  );
};

export default TransferStock;
